import { card } from "@universityofmaryland/web-elements-library/composite";
import { createTextWithLink, createTextContainer, createTimeElement, createImageOrLinkedImage } from "@universityofmaryland/web-utilities-library/elements";
const newsDisplayStrategy = {
  layoutType: "grid",
  mapEntryToCard: (entry, options) => {
    const {
      isThemeDark = false,
      isTransparent = false,
      isAligned = true,
      imageConfig,
      isOverlay = false,
      cardType = "block"
    } = options;
    const headline = createTextWithLink({
      text: entry.title,
      url: entry.url
    });
    const text = createTextContainer({
      text: entry.summary
    });
    const date = createTimeElement({
      datetime: entry.date,
      displayText: entry.dateFormatted
    });
    const commonProps = {
      newsId: entry.id.toString(),
      headline,
      text,
      date,
      isThemeDark
    };
    if (isOverlay && imageConfig) {
      const config = imageConfig(entry);
      if (config) {
        const backgroundImage = createImageOrLinkedImage(config);
        return card.overlay.image({
          ...commonProps,
          backgroundImage
        });
      }
    }
    const imageResult = imageConfig ? imageConfig(entry) : null;
    const image = imageResult ? createImageOrLinkedImage(imageResult) : void 0;
    if (cardType === "list") {
      return card.list({
        ...commonProps,
        image,
        isAligned: false
      });
    }
    return card.block({
      ...commonProps,
      image,
      isAligned,
      isTransparent
    });
  }
};
export {
  newsDisplayStrategy
};
//# sourceMappingURL=news.js.map
